// btw-front/src/components/sections/Process.jsx
import React, { useMemo } from "react";
import Container from "../ui/Container";
import { Fade } from "react-awesome-reveal";
import { useTranslation } from "react-i18next";

export default function Process() {
  const { t } = useTranslation();
  const steps = useMemo(() => {
    return t("process.steps", { returnObjects: true }) || [];
  }, [t]);

  return (
    <section id="process" className="btw-section bg-slate-100">
      <Container>
        <Fade direction="up" triggerOnce>
          <div className="max-w-2xl">
            <span className="btw-eyebrow">Process</span>
            <h2 className="btw-h2 mt-4">{t("section.processTitle")}</h2>
            <p className="btw-lead">{t("section.processDesc")}</p>
          </div>
        </Fade>

        {/* 가로형 단계 카드: lg에서 한 줄 흐름, 번호 배지 강조 */}
        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-6">
          {steps.map((s, i) => (
            <Fade key={s.n} direction="up" delay={i * 60} triggerOnce>
              <div className="btw-card-hover flex h-full flex-col p-5">
                <div className="flex h-9 w-9 items-center justify-center rounded-full bg-accent/10 text-sm font-bold text-accent">
                  {s.n}
                </div>
                <div className="mt-4 text-sm font-semibold text-slate-900">{s.title}</div>
                <p className="mt-2 text-xs leading-relaxed text-slate-600">{s.desc}</p>
              </div>
            </Fade>
          ))}
        </div>
      </Container>
    </section>
  );
}
